import React from 'react'
import { func, string } from 'prop-types'
import styled from 'styled-components'
import NumericalValue from './NumericalValue'

import { numericalFormatterSplitted } from '../utils/num'

interface Props {
  value: number
  precision?: number
  currency: any
  numericFontSize?: string
  nonNumericFontSize?: string
}
function CurrencyValue({ value, currency, precision = 4, numericFontSize, nonNumericFontSize }: Props) {
  const [val, format] = numericalFormatterSplitted(value, precision)
  return <div style={{display:'flex'}}>
      <NumericalValue fontSize={nonNumericFontSize}>{currency}</NumericalValue>
      <NumericalValue fontSize={numericFontSize}>{val}</NumericalValue>
      <NumericalValue fontSize={nonNumericFontSize}>{format}</NumericalValue>
    </div>
}

export default CurrencyValue
